import {
  Box,
  Typography
} from '@mui/material';
import React, { useState } from 'react';

import { PollResponseFilters } from '../../../types';
import PollResponseForm from './PollResponseForm';
import PollResponsePrecinctReport from './PollResponsePrecinctReport';

interface PollResponseReportProps {
}

const PollResponseReport: React.FC<PollResponseReportProps> = () => {
  const [filters, setFilters] = useState<PollResponseFilters>();

  const onGenerateReport = (filters: PollResponseFilters) => {
    console.log('Generating report with filters:', filters);
    setFilters(filters);
  };

  return (
    <Box sx={{ flexGrow: 1, p: 2 }}>
      <Typography variant="h6" gutterBottom>
        Poll Responses
      </Typography>
      <PollResponseForm onGenerateReport={onGenerateReport} />
      { filters && <PollResponsePrecinctReport filters={filters} /> }
    </Box>
  );
};

export default PollResponseReport;
